<h3>{{ 'GLOBAL.CHANGELANGUAGE.HEADER' | translate }}</h3>

@if (!languageChanged) {
  <form #changeLanguageForm="ngForm" (ngSubmit)="clickChangeLanguage()">
    <phscw-input-select
      [editMode]="true"
      label="{{ 'GENERAL.LANGUAGE' | translate }}"
      name="language_key"
      inputId="language_key"
      [(ngModel)]="languageKey"
      listentries="availableLanguages"
    [disabled]="saving"></phscw-input-select>
    <!-- Buttons Submit & Cancel -->
    <div class="cw-button-wrapper">
      <button mat-raised-button color="accent" type="submit" [disabled]="saving">
        {{ 'GLOBAL.CHANGELANGUAGE.ACTION' | translate }}
        <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
      </button>
      <button mat-raised-button color="primary" type="button" (click)="clickAndClose()">
        {{ 'GENERAL.CANCEL' | translate }}
      </button>
    </div>
  </form>
}

@if (languageChanged) {
  <div class="cw-color-orange cw-login-error">
    <span>{{ 'GLOBAL.CHANGELANGUAGE.SUCCESS' | translate }}</span>
  </div>
  <div class="cw-button-wrapper">
    <button mat-raised-button color="primary" type="button" (click)="clickAndClose()">
      {{ 'GENERAL.CLOSE' | translate }}
    </button>
  </div>
}
